import Card from "./Card";
import Stack from "./Stack";
import Footer from "./Footer";
import Header from "./Header";
import Title from "./Title";
import Text from "./Text";
import Body from "./Body";
import Counter from "./Counter";
import StepTitle from "./StepTitle";
import HelpIcon from "./HelpIcon/HelpIcon";
import CompleteStatus from "./CompleteStatus";

Card.Stack = Stack;
Card.Title = Title;
Card.Footer = Footer;
Card.Header = Header;
Card.Text = Text;
Card.Body = Body;
Card.Counter = Counter;
Card.StepTitle = StepTitle;
Card.HelpIcon = HelpIcon;
Card.CompleteStatus = CompleteStatus;

export default Card;
